/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreateClaim/Charges/Charge/ToothSurface/Content",
  onChange
  
}) {
let chargeToothSurfaceValueData = fromData.useDataValue({ viewPath,
context: 'charge',
path: 'tooth_surface',
})
let chargeToothSurfaceChangeData = fromData.useDataChange({ viewPath,
context: 'charge',
path: 'tooth_surface',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="charge.tooth_surface"
 value={chargeToothSurfaceValueData}
 onChange={chargeToothSurfaceChangeData}
 autoFocus={false}
 marginTop={0}
 width={168}
 placeholder="Tooth surface"
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}